import { Inject, Injectable } from '@angular/core';
import { MwCompanyService } from '@core/auth';
import { Config, MW_APP_CONFIG, MwAppConfigService } from '@core/config';



@Injectable()
export class MwAppToolbarService {
  get companyLogoUrl(): string {
    if (this.config?.layout?.toolbar?.showCompanyLogo === true) {
      const companyId = this.companyService.instantActiveCompanyId;
      return `${+this._config.environment
        .baseUrl}/integration/v1/companies/${companyId}/logo`;
    }
    return null;
  }

  private config: Config;
  constructor(
    private readonly configService: MwAppConfigService,
    private readonly companyService: MwCompanyService,
    @Inject(MW_APP_CONFIG) private readonly _config: Config
  ) {
    this.configService
      .getConfig()
      .subscribe((config) => (this.config = config));
  }
}
